<section
        [style.marginTop.px]="marginTop"
        class="container-fluid main container-stick"
    >
        <div class="container-xl">
            <div
                class="row gx-13 justify-content-center justify-content-xs-center justify-content-sm-center justify-content-md-start justify-content-lg-center"
            >
                <div class="col-auto">
                    <h1 class="mt-16 mb-17">
                        {{ 'fe_step4_h1_title' | translate }}
                    </h1>
                </div>
                <div class="col-7"></div>
            </div>
            <div class="row gx-13 justify-content-center">
                <div
                    class="col-12 d-flex d-md-block justify-content-center col-md-5 col-lg-auto px-md-0 px-lg-2"
                >
                    <fe-summary></fe-summary>
                </div>
                <div class="col-12 col-md-7 col-lg-7">
                    <div class="container-fluid">
                        <div
                            class="row mb-6 mt-17 mt-md-0 justify-content-between"
                        >
                            <div class="p-0 col-auto">
                                <h2 class="mb-0">
                                    {{
                                        'fe_step4_information_h2_title'
                                            | translate
                                    }}
                                </h2>
                            </div>
                            <div class="p-0 col-auto extra-message">
                                {{
                                    'fe_step4_information_div_instructions'
                                        | translate
                                }}
                            </div>
                        </div>
                        <form [formGroup]="formPersonalInfo">
                            <div class="row mb-10">
                                <div
                                    class="container-fluid gx-lg-12 container-personal-info"
                                >
                                    <div class="row mt-18">
                                        <div class="col-12 col-md-6">
                                            <h3>
                                                {{
                                                    'fe_step4_information_h3_subtitle'
                                                        | translate
                                                }}
                                            </h3>
                                        </div>
                                    </div>
                                    <div class="row gx-2">
                                        <div class="col-12 col-sm-6">
                                            <fe-input
                                                class="mb-6"
                                                [id]="'names'"
                                                [label]="
                                                    'fe_step4_information_label_names'
                                                        | translate
                                                "
                                                (keypress)="onlyLetters($event)"
                                                [formControlName]="'names'"
                                            ></fe-input>
                                        </div>
                                        <div class="col-12 col-sm-6">
                                            <fe-input
                                                class="mb-6"
                                                [id]="'lastName'"
                                                [label]="
                                                    'fe_step4_information_label_last-name'
                                                        | translate
                                                "
                                                (keypress)="onlyLetters($event)"
                                                [formControlName]="'lastName'"
                                            ></fe-input>
                                        </div>
                                    </div>
                                    <div class="row gx-2">
                                        <div class="col-12 col-sm-6">
                                            <fe-input
                                                class="mb-6"
                                                [id]="'email'"
                                                [type]="'email'"
                                                [label]="
                                                    'fe_step4_information_label_email'
                                                        | translate
                                                "
                                                [formControlName]="'email'"
                                            ></fe-input>
                                        </div>
                                        <ng-template
                                            [ngIf]="
                                                reservation.current.origin ===
                                                'NAT'
                                            "
                                        >
                                            <div class="col-12 col-sm-6">
                                                <fe-phone-lada-input
                                                    class="d-block mb-6"
                                                    [form]="formPersonalInfo"
                                                    [label]="
                                                        'fe_step4_information_label_phone'
                                                            | translate
                                                    "
                                                ></fe-phone-lada-input>
                                            </div>
                                        </ng-template>
                                    </div>
                                    <ng-template
                                        [ngIf]="
                                            reservation.current.origin === 'NAT'
                                        "
                                    >
                                        <div class="row gx-2">
                                            <div class="col-12 col-sm-6">
                                                <div
                                                    class="container-fluid gx-0 mb-6 container-checkbox-type-trip"
                                                >
                                                    <div class="row">
                                                        <div
                                                            class="col-12 title-checkbox"
                                                        >
                                                            {{
                                                                'fe_step4_information_label_type-trip'
                                                                    | translate
                                                            }}
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="row gx-2 container-checkbox-type-trip-inputs justify-content-evenly"
                                                    >
                                                        <div class="col-auto">
                                                            <input
                                                                class="form-check-input secondary"
                                                                type="radio"
                                                                name="typeTrip"
                                                                id="pleasure"
                                                                checked
                                                                value="Placer"
                                                                formControlName="typeTrip"
                                                            />
                                                            <label
                                                                class="form-check-label"
                                                                for="pleasure"
                                                            >
                                                                {{
                                                                    'fe_step4_information_label_type-trip-pleasure'
                                                                        | translate
                                                                }}
                                                            </label>
                                                        </div>
                                                        <div class="col-auto">
                                                            <input
                                                                class="form-check-input"
                                                                type="radio"
                                                                name="typeTrip"
                                                                id="business"
                                                                value="Negocios"
                                                                formControlName="typeTrip"
                                                            />
                                                            <label
                                                                class="form-check-label"
                                                                for="business"
                                                            >
                                                                {{
                                                                    'fe_step4_information_label_type-trip-business'
                                                                        | translate
                                                                }}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-template>
                                    <div class="row mb-6 container-check-mail">
                                        <div class="col-12">
                                            <input
                                                class="form-check-input mt-0"
                                                type="checkbox"
                                                [(ngModel)]="
                                                    checkBoxs.checkPromotions
                                                "
                                                [ngModelOptions]="{
                                                    standalone: true
                                                }"
                                                id="checkPromotions"
                                            />
                                            <label
                                                class="form-check-label"
                                                for="checkPromotions"
                                            >
                                                {{
                                                    'fe_step4_information_label_promotions'
                                                        | translate
                                                }}
                                            </label>
                                        </div>
                                    </div>
                                    <div
                                        class="row container-check-mail-ty row mb-18"
                                    >
                                        <div class="col-12 d-flex flex-wrap">
                                            <div class="d-inline">
                                                {{
                                                    'fe_step4_information_div_check-promotions'
                                                        | translate
                                                }}
                                                <a
                                                    class="privacy-policy"
                                                    [target]="'_blank'"
                                                    [href]="
                                                        'questions/privacy-policy'
                                                            | formatUrl
                                                    "
                                                    >{{
                                                        'fe_step4_information_a_check-privacy-policy'
                                                            | translate
                                                    }}</a
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div class="row mb-10">
                            <fe-rental-requirements></fe-rental-requirements>
                        </div>
                        <div class="row">
                            <div
                                class="container-fluid gx-lg-12 container-personal-info"
                            >
                                <div class="row mt-18 mb-19">
                                    <div class="col-12">
                                        <h3>
                                            {{
                                                'fe_step4_complete_reservation_h3_title'
                                                    | translate
                                            }}
                                        </h3>
                                    </div>
                                </div>
                                <div
                                    class="row mb-13 flex-nowrap justify-content-between container-total"
                                >
                                    <div
                                        *ngIf="
                                            reservation.current.flowType ===
                                            'office'
                                        "
                                        class="col"
                                    >
                                        {{
                                            getOfficeSubtitleKey() | translate
                                        }}
                                    </div>
                                    <div
                                        *ngIf="
                                            reservation.current.flowType ===
                                            'prepaid'
                                        "
                                        class="col"
                                    >
                                        {{
                                            getPrepaidSubtitleKey() | translate
                                        }}
                                    </div>
                                    <div class="col-auto text-end">
                                        <div>
                                            ${{ reservation.total | number: '1.2-2':'en-IN' }}
                                            {{ reservation.current.currency }}
                                        </div>
                                        <div
                                            class="container-total__saving"
                                            *ngIf="savings > 0"
                                        >
                                            <img
                                                [src]="'images/percentage.svg' | cdn"
                                                alt="discount"
                                            />
                                            <span
                                                >{{
                                                    'fe_step5_summary_div_title-saving'
                                                        | translate
                                                }}
                                                ${{ savings | number: '1.2-2':'en-IN' }}
                                                {{ reservation.current.currency }}</span
                                            >
                                        </div>
                                    </div>
                                </div>
                                <div class="protection-notice" *ngIf="isLite">
                                    <img
                                        class="protection-notice__icon"
                                        [src]="'images/whitout_extras.svg' | cdn"
                                        alt=""
                                    />
                                    <div class="protection-notice__body">
                                        <p class="protection-notice__title">
                                            {{
                                                'fe_step4_protection_notice_title'
                                                    | translate
                                            }}
                                        </p>
                                        <p class="protection-notice__text">
                                            {{
                                                getProtectionNoticeTextKey()
                                                    | translate
                                            }}
                                        </p>
                                    </div>
                                </div>
                                <div class="row mb-6 container-check-mail">
                                    <div class="col-12">
                                        <input
                                            class="form-check-input mt-0"
                                            type="checkbox"
                                            [(ngModel)]="checkBoxs.checkTerms"
                                            id="acceptTY"
                                        />
                                        <label
                                            class="form-check-label d-flex flex-wrap"
                                            for="acceptTY"
                                        >
                                            {{
                                                'fe_step4_complete_reservation_label_accept'
                                                    | translate
                                            }}&nbsp;
                                            <fe-button
                                                [btnClass]="'p-0 border-0'"
                                                [style]="'link-tertiary'"
                                                [target]="'_blank'"
                                                [href]="
                                                    'questions/car-rental-conditions-and-policies'
                                                        | formatUrl
                                                "
                                                >{{
                                                    'fe_step4_complete_reservation_a_rental-privacy'
                                                        | translate
                                                }}</fe-button
                                            >
                                            &nbsp;
                                            <fe-button
                                                [btnClass]="'p-0 border-0'"
                                                [style]="'link-tertiary'"
                                                [target]="'_blank'"
                                                [href]="
                                                    'questions/car-rental-conditions-and-policies'
                                                        | formatUrl
                                                "
                                                >{{
                                                    'fe_step4_complete_reservation_a_rental-privacy-warranty'
                                                        | translate
                                                }}</fe-button
                                            >
                                            &nbsp;
                                            <fe-button
                                                [btnClass]="'p-0 border-0'"
                                                [style]="'link-tertiary'"
                                                [target]="'_blank'"
                                                [href]="
                                                    'questions/refunds-policy'
                                                        | formatUrl
                                                "
                                                >{{
                                                    'fe_step4_complete_reservation_a_refunds-policy'
                                                        | translate
                                                }}</fe-button
                                            >
                                        </label>
                                    </div>
                                    <div
                                        *ngIf="
                                            !checkBoxs.checkTerms &&
                                            btnReservate.clicked
                                        "
                                        class="is-invalid"
                                    ></div>
                                    <div
                                        *ngIf="
                                            !checkBoxs.checkTerms &&
                                            btnReservate.clicked
                                        "
                                        class="feedback invalid-feedback check-tyc"
                                    >
                                        {{
                                            'fe_core_errors_input_required'
                                                | translate
                                        }}
                                    </div>
                                </div>
                                <div class="row mb-18">
                                    <div class="col-12 col-sm-auto">
                                        <fe-button
                                            #btnReservate
                                            [loading]="loadingBtnReservate"
                                            class="d-grid"
                                            [style]="'tertiary'"
                                            [btnClass]="'border-0'"
                                            (onClick)="onClicReservate()"
                                            [disabled]="
                                                configuration.featuresFlags
                                                    .value?.reservation !== true
                                            "
                                        >
                                            {{
                                                'fe_step4_complete_reservation_' +
                                                    reservation.current
                                                        .flowType +
                                                    '_reserve-now' | translate
                                            }}
                                        </fe-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</section>
